import { get, map, compose } from 'lodash/fp';

import { createRgFormAPI } from '~/api/core/rgRequest';

const extractSources = compose([
  map(get('name')),
  get('sources'),
  get('data'),
]);

const extractTypes = compose([
  get('roles'),
  get('data'),
]);


const getLeadTypesAPI = createRgFormAPI('/get_lead_types_from_lead_manager');
const getLeadSourceAPI = createRgFormAPI('/get_lead_sources_from_lead_manager');

export const getLeadTypes = (): Promise<string[]> => getLeadTypesAPI.post().then(extractTypes);
export const getLeadSources = (): Promise<string[]> => getLeadSourceAPI.post().then(extractSources);
